export default __webpack_public_path__ + "static/media/symfony.9250cc02.svg";